"use client"

import React from 'react'
import { WorkflowFlowchart } from '@/features/homeowners/components/workflow-flowchart'
import { OrganizationOptionsProvider } from '@/features/homeowners/context/organization-options-context'

type WorkflowTabProps = {
    homeId: number | null
}

export default function WorkflowTab({ homeId }: WorkflowTabProps) {
    if (!homeId) {
        return (
            <div className="rounded-lg border p-5 text-center text-muted-foreground">
                No home data available for this homeowner.
            </div>
        )
    }

    return (
        <OrganizationOptionsProvider>
            <WorkflowFlowchart homeId={homeId} />
        </OrganizationOptionsProvider>
    )
}

